import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import SingleRangeBuckets_Coral from "./SingleRangeBuckets_Coral";
import SingleRangeBox_Coral from "./SingleRangeBox_Coral";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function TwoChartTemplate_Coral({ title, type, gloablfilter }) {
  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div
        className={
          !(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
            ? "chartbox drive_graph"
            : "chartbox drive_graph p-0"
        }
      >
        {/* <div className="row"> */}
        <div className={!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") ? "row" : ""}>
          <div
            className={
              !(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") ? "col-md-12" : ""
            }
          >
            <div
              className={
                !(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                  ? "titlebg titlebd_drive p-2 pb-0"
                  : "titlebg titlebd_drive box_title pt-2 pb-2"
              }
            >
              {title}
            </div>
          </div>
          {type === "RANGE" ? (
            <>
              {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                <SingleRangeBox_Coral
                  title={title}
                  gloablfilter={gloablfilter}
                  apiend="rangeboxchart"
                  yaxis_title="Range"
                  idStr="Range"
                />
              )}
              <SingleRangeBuckets_Coral
                title={title}
                gloablfilter={gloablfilter}
                apiend={
                  !(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "rangebarchart"
                    : "rangebarchart_erc"
                }
                yaxis_title="Vehicle Count"
              />
            </>
          ) : (
            <>
              {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                <SingleRangeBox_Coral
                  title={title}
                  gloablfilter={gloablfilter}
                  apiend="energyboxchart"
                  yaxis_title="Wh/km"
                  idStr="Whkm"
                />
              )}
              <SingleRangeBuckets_Coral
                title={title}
                gloablfilter={gloablfilter}
                apiend={
                  !(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                    ? "energybarchart"
                    : "energybarchart_erc"
                }
                yaxis_title="Vehicle Count"
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default TwoChartTemplate_Coral;
